import $ from 'jquery';
window.$ = window.jQuery = $;
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';

jQueryBridget( 'imagesLoaded', imagesLoaded, $ );

(function($, window, document) {
	"use strict";

  var TLS_Trattamenti = function() {

    var self = this,
    grid;

    // 
    this.images_loaded = function () {
      $('.grid-trattamenti').imagesLoaded(function() {
        self.masonry_init();
      });
    };

    this.masonry_init = function () {
      grid = $('.grid-trattamenti').isotope({
        layoutMode: 'fitRows',
        itemSelector: '.grid-item',
        filter: '*',
      });

      grid.on('arrangeComplete', function() {
        // Trigger AOS.refresh() dopo ogni filtro Isotope
        window.updateAOS();
      });
      
    };

    this.button = function(e){
      $('.filter-button').removeClass('active');
      $(this).addClass('active');
    };

    this.filter = function(e){
      var filterValue = $(this).attr('data-filter');
      grid.isotope({ filter: filterValue });
    };
    
    this.bind = function() {
      $( document ).on( 'ready', self.images_loaded );
      $( document ).on( 'click', '.filter-button', self.button );
      $( document ).on( 'click', '.filters-button-group a', self.filter );
      
    };
        
    this.init = function() {
		  self.bind();
	  };

		this.init();
  };

  ( new TLS_Trattamenti() );
   
}(window.jQuery, window, document));



